import React from 'react';
import { Checkbox, Button } from 'antd';
import { PlusOutlined, MinusOutlined, DeleteOutlined, StarOutlined } from '@ant-design/icons';
import CartCounter from '@/components/CartCounter';
import styles from './CartListGroup.module.scss';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from "react-i18next";
export interface CartShop {
  shopId: string;
  shopName: string;
  checked: boolean;
  products: CartProduct[];
}

export interface CartProduct {
  id: string;
  cart_id?: number; // 购物车ID
  img: string;
  title: string;
  price: string;
  color: Array<{
    lable: string;
    value: string;
    product_base_attribute_id: number;
  }>;
  quantity: number;
  checked: boolean;
  promotion?: string;
  payType?: string;
  services?: string[];
  purchaseLimit?: string;
  maxQuantity?: number;
  skuId?: string;
  customAttributes?: string;
  deliveryMethod?: number; // 交货方式
  deliveryMethodText?: string; // 交货方式文本
}

interface CartListGroupProps {
  shops: CartShop[];
  onShopCheck: (shopId: string, checked: boolean) => void;
  onProductCheck: (shopId: string, productId: string, checked: boolean) => void;
  onQuantityChange: (shopId: string, productId: string, quantity: number) => void;
  onDelete: (shopId: string, productId: string) => void;
  onCollect: (shopId: string, productId: string) => void;
}

// 商品项组件
const CartProductItem: React.FC<{

  product: CartProduct;
  onCheck: (checked: boolean) => void;
  onQuantityChange: (quantity: number) => void;
  onDelete: () => void;
  onCollect: () => void;
}> = ({ product, onCheck, onQuantityChange, onDelete, onCollect }) => {
  //console.log("product ==== ",product)
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  return (
    <div className={styles['cart-product-item']}>
      <div className={styles['cart-prodict-box1']}>
      <div className={styles['cart-product-main']}>
        <div className={styles['cart-col-checkbox']}>
          <Checkbox checked={product.checked} onChange={e => onCheck(e.target.checked)} />
          <img className={styles['cart-product-img']} src={product.img} alt={product.title} onClick={() => navigate(`/ProductDetail/${product.id.split('_')[0]}`)} />
        </div>
        <div className={styles['cart-col-info']}>
          <div className={styles['cart-product-title']}>{product.title}</div>
          {product.payType && (
            <div className={styles['cart-product-paytype']}>{product.payType}</div>
          )}
          {product.deliveryMethodText && (
            <div className={styles['cart-product-delivery']}>
              <span className={styles['cart-product-delivery-label']}>{t('Cart.DeliveryMethod')}:</span>
              <span className={styles['cart-product-delivery-text']}>{product.deliveryMethodText}</span>
            </div>
          )}
          {product.services && product.services.length > 0 && (
            <div className={styles['cart-product-services']}>
              {product.services.map((service, index) => (
                <span key={index} className={styles['cart-product-paytype']}>{service}</span>
              ))}
            </div>
          )}
        </div>
      </div>
      {product.promotion && (
        <div className={styles['cart-producrt-ifPromotion']}>
              <span>{t('Cart.Promotion')}</span>
              <span> {product.promotion}</span>
        </div>
      )}
      </div>
      <div className={styles['cart-product-meta-block']}>
        <div className={styles['cart-product-colour']}>
          {Array.isArray(product.color) ? (
            product.color.map((spec, index) => (
              <div key={index} className={styles['cart-product-spec']}>
                {spec.lable}: {spec.value}
              </div>
            ))
          ) : (
            <div>{product.color}</div>
          )}
        </div>
       
      </div>
      <div className={styles['cart-product-weight-price']}>
        <span>${product.price}</span>
      </div>
      <div className={styles['cart-col-quantity']}>
        <CartCounter
          initialValue={product.quantity}
          min={1}
          max={product.maxQuantity || 99}
          onChange={onQuantityChange}
        />
        {product.purchaseLimit && (
          <div className={styles['cart-product-limit']}>{product.purchaseLimit}</div>
        )}
      </div>
      <div className={styles['cart-col-actions']}>
        {/* <Button size="small" style={{color:"#7F9298"}} onClick={onCollect} type="link">Bookmark</Button> */}
        <Button size="small" style={{color:"#7F9298"}} onClick={onDelete} type="link" >{t('Cart.Delete')}</Button>
      </div>
    </div>
  );
};

// 店铺块组件
const CartShopBlock: React.FC<{
  shop: CartShop;
  onShopCheck: (checked: boolean) => void;
  onProductCheck: (productId: string, checked: boolean) => void;
  onQuantityChange: (productId: string, quantity: number) => void;
  onDelete: (productId: string) => void;
  onCollect: (productId: string) => void;
}> = ({ shop, onShopCheck, onProductCheck, onQuantityChange, onDelete, onCollect }) => {
  return (
    <div className={styles['cart-shop-block']}>
      <div className={styles['cart-shop-header']}>
        <Checkbox checked={shop.checked} onChange={e => onShopCheck(e.target.checked)}>
          {shop.shopName}
        </Checkbox>
      </div>
      <div className={styles['cart-shop-products']}>
        {shop.products.map(product => (
          <CartProductItem
            key={product.id}
            product={product}
            onCheck={checked => onProductCheck(product.id, checked)}
            onQuantityChange={quantity => onQuantityChange(product.id, quantity)}
            onDelete={() => onDelete(product.id)}
            onCollect={() => onCollect(product.id)}
          />
        ))}

      </div> 
    </div>
  );
};

// 主列表组件
const CartListGroup: React.FC<CartListGroupProps> = (
  { 
  shops, 
  onShopCheck, 
  onProductCheck, 
  onQuantityChange, 
  onDelete, 
  onCollect 
}) => {
  return (
    <div className={styles['cart-list-group']}>
      {shops.map(shop => (
        <CartShopBlock
          key={shop.shopId}
          shop={shop}
          onShopCheck={checked => onShopCheck(shop.shopId, checked)}
          onProductCheck={(productId, checked) => onProductCheck(shop.shopId, productId, checked)}
          onQuantityChange={(productId, quantity) => onQuantityChange(shop.shopId, productId, quantity)}
          onDelete={productId => onDelete(shop.shopId, productId)}
          onCollect={productId => onCollect(shop.shopId, productId)}
        />
      ))}
    </div>
  );
};

export default CartListGroup; 